export const logos = {
  Languages: [
    { src: "/logos/java.svg", label: "Java" },
    { src: "/logos/javascript.svg", label: "JavaScript" },
    { src: "/logos/typescript.svg", label: "TypeScript" },
    { src: "/logos/html.svg", label: "HTML" },
    { src: "/logos/rust.svg", label: "Rust" },
  ],
  Web: [
    { src: "/logos/bootstrap.svg", label: "Bootstrap" },
    { src: "/logos/graphql.svg", label: "GraphQL" },
    { src: "/logos/hibernate.svg", label: "Hibernate" },
    { src: "/logos/j2ee.svg", label: "J2EE" },
    { src: "/logos/jquery.svg", label: "jQuery" },
    { src: "/logos/material-ui.svg", label: "Material UI" },
    { src: "/logos/node.svg", label: "Node.js" },
    { src: "/logos/redux.svg", label: "Redux" },
    { src: "/logos/css.svg", label: "CSS" },
  ],
  Databases: [
    { src: "/logos/cassandra.svg", label: "Cassandra" },
    { src: "/logos/oracle.svg", label: "Oracle" },
    { src: "/logos/postgresql.svg", label: "PostgreSQL" },
    { src: "/logos/dynamodb.svg", label: "DynamoDB" },
  ],
  Deployment: [
    { src: "/logos/aws.svg", label: "AWS" },
    { src: "/logos/docker.svg", label: "Docker" },
    { src: "/logos/jenkins.svg", label: "Jenkins" },
    { src: "/logos/linux.svg", label: "Linux" },
    { src: "/logos/tomcat.svg", label: "Tomcat" },
  ],
};
